// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-infos-card {
  background-color: var(--primary-button-color);
  border-color: var(--primary-button-color);
  width: 20rem;
  height: 12rem;
  padding: 2rem !important;
}
@media (max-width: 1000px) {
  .loan-infos-card {
    height: 10rem;
    width: 100%;
    padding: 1.5rem !important;
  }
  .loan-infos-card .loan-infos-card-image {
    border-top-right-radius: 24px;
  }
}
.loan-infos-card .ant-card-body {
  height: 100%;
}
.loan-infos-card .loan-infos-card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.loan-infos-card .loan-infos-card-content .loan-infos-card-top .loan-infos-card-icon svg {
  font-size: 1.2rem;
  color: var(--primary-button-text-color);
}
.loan-infos-card .loan-infos-card-content .loan-infos-card-top .loan-infos-card-title {
  font-size: 1.2rem;
  color: var(--primary-button-text-color);
}
.loan-infos-card .loan-infos-card-content .loan-infos-card-bottom .loan-infos-card-value {
  font-size: 1.6rem;
  font-weight: 500;
  color: var(--primary-button-text-color);
}
.loan-infos-card .loan-infos-card-content .loan-infos-card-image {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateY(1px) translateX(1px);
  border-bottom-right-radius: 20px;
}
.loan-infos-card .loan-infos-card-content .loan-infos-card-image g {
  fill: var(--primary-button-text-color);
}
.loan-infos-card .point-up {
  transform: rotate(-90deg);
  padding: 0;
  padding-top: 0.5rem;
  padding-right: 0.3rem;
}
.loan-infos-card .point-down {
  padding: 0;
  padding-bottom: 0.5rem;
  padding-right: 0.3rem;
  transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/cards/LoanInfoCard/styles.less"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;AACF;AACE;EAAA;IACE,aAAA;IACA,WAAA;IACA,0BAAA;EAEF;EALA;IAMI,6BAAA;EAEJ;AACF;AAhBA;EAkBI,YAAA;AACJ;AAnBA;EAsBI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AAzBA;EA8BU,iBAAA;EACA,uCAAA;AAFV;AA7BA;EAmCQ,iBAAA;EACA,uCAAA;AAHR;AAjCA;EAyCQ,iBAAA;EACA,gBAAA;EACA,uCAAA;AALR;AAtCA;EAgDM,kBAAA;EACA,SAAA;EACA,QAAA;EACA,0CAAA;EACA,gCAAA;AAPN;AA7CA;EAuDQ,sCAAA;AAPR;AAhDA;EA6DI,yBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AAVJ;AAtDA;EAmEI,UAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;AAVJ","sourcesContent":[".loan-infos-card {\n  background-color: var(--primary-button-color);\n  border-color: var(--primary-button-color);\n  width: 20rem;\n  height: 12rem;\n  padding: 2rem !important;\n\n  @media (max-width: 1000px) {\n    height: 10rem;\n    width: 100%;\n    padding: 1.5rem !important;\n\n    .loan-infos-card-image {\n      border-top-right-radius: 24px;\n    }\n  }\n\n  .ant-card-body {\n    height: 100%;\n  }\n\n  .loan-infos-card-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n\n    .loan-infos-card-top {\n      .loan-infos-card-icon {\n        svg {\n          font-size: 1.2rem;\n          color: var(--primary-button-text-color);\n        }\n      }\n      .loan-infos-card-title {\n        font-size: 1.2rem;\n        color: var(--primary-button-text-color);\n      }\n    }\n    .loan-infos-card-bottom {\n      .loan-infos-card-value {\n        font-size: 1.6rem;\n        font-weight: 500;\n        color: var(--primary-button-text-color);\n      }\n    }\n\n    .loan-infos-card-image {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      transform: translateY(1px) translateX(1px);\n      border-bottom-right-radius: 20px;\n\n      g {\n        fill: var(--primary-button-text-color);\n      }\n    }\n  }\n\n  .point-up {\n    transform: rotate(-90deg);\n    padding: 0;\n    padding-top: 0.5rem;\n    padding-right: 0.3rem;\n  }\n  .point-down {\n    padding: 0;\n    padding-bottom: 0.5rem;\n    padding-right: 0.3rem;\n    transform: rotate(90deg);\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
